import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 24.5 20.1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "var(--stroke-0, #B68559)",
      "stroke-width": "2.5"
    }, [
      _createElementVNode("path", { d: "M18.85 18.85a4.4 4.4 0 1 0 0-8.8 4.4 4.4 0 0 0 0 8.8ZM5.65 18.85a4.4 4.4 0 1 0 0-8.8 4.4 4.4 0 0 0 0 8.8Z" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "m14.45 14.686-.721-.258a4.4 4.4 0 0 0-2.957 0l-.722.258m-8.8-.236.84-9.234c.126-1.39.19-2.086.597-2.6.407-.513 1.069-.734 2.393-1.176l.57-.19m17.6 13.2-.84-9.234c-.126-1.39-.188-2.086-.595-2.6-.407-.513-1.07-.734-2.395-1.176l-.57-.19"
      })
    ], -1)
  ]))]))
}
export default { render: render }